import LeftNode from './LeftNode'

export default class StarterAccu extends LeftNode {
  constructor() {
    super()
  }

  getChildCandidates () {
    return ["alternator"] 
  }
}
